/**
 * Centralized theme color mapping module.
 * Provides theme-aware color palettes so components can swap between
 * dark and light themes without structural changes.
 *
 * This module uses CommonJS (module.exports) for compatibility with both:
 * - Backend Node.js controllers (require statements)
 * - Frontend React components via Webpack (import statements)
 *
 * @module themeColors
 */

const THEME_VALUES = {
  DARK: 'dark',
  LIGHT: 'light',
};

const darkPalette = {
  backgroundPrimary: '#1a1a2e',
  backgroundSecondary: '#16213e',
  textPrimary: '#e0e0e0',
  textSecondary: '#ccc',
  textMuted: '#aaa',
  textFaint: '#888',
  accentPrimary: '#8ab4f8',
  accentSecondary: '#3498db',
  borderPrimary: '#2a2a4a',
  cardBackground: '#1a1a2e',
  accentBg: '#1e2a4a',
};

const lightPalette = {
  backgroundPrimary: '#ffffff',
  backgroundSecondary: '#f5f5f5',
  textPrimary: '#1a1a1a',
  textSecondary: '#333',
  textMuted: '#666',
  textFaint: '#999',
  accentPrimary: '#1971c2',
  accentSecondary: '#2980b9',
  borderPrimary: '#e0e0e0',
  cardBackground: '#ffffff',
  accentBg: '#e3f2fd',
};

/**
 * Returns a color palette object for the given theme.
 * Both palettes return objects with the same property names
 * so components can swap without structural changes.
 *
 * @param {string} theme - 'dark' or 'light'
 * @returns {object} Color palette with backgroundPrimary, backgroundSecondary,
 *   textPrimary, textSecondary, textMuted, textFaint, accentPrimary,
 *   accentSecondary, borderPrimary, cardBackground
 */
function getThemeColors(theme) {
  return theme === THEME_VALUES.LIGHT ? lightPalette : darkPalette;
}

module.exports = { getThemeColors, THEME_VALUES };
